/**
 * Everything the app leaves in localStorage for the signed-in user.
 *
 * Logout used to remove only the two tokens, so the persisted `portfolio` slice and
 * the last portfolio selection stayed behind. On a shared machine the next person
 * saw the previous user's portfolio until the first fetch replaced it.
 *
 * `language` is deliberately not cleared: it is also the language of the login
 * screen, and it carries nothing about the user.
 */
const SESSION_KEYS = [
  "accessToken",
  "refreshToken",
  // Read by Sidebar and PortfolioSelect; separate from the persisted store slice.
  "portfolio",
  // Written by an MVP module that was never wired into any view and has since been
  // removed. Kept here so a key left behind by an older build is cleared too.
  "derivative_termination_history_v1",
];

// easy-peasy's persist() writes under "[<storeName>][<version>][<path>]", so the
// literal slice name never appears as a key. Matching the prefix keeps this working
// if the store is renamed or its persist version bumped.
const STORE_KEY_PREFIX = "[EasyPeasyStore]";

export const clearSessionStorage = () => {
  SESSION_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // Private mode or blocked storage: nothing to clear.
    }
  });

  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(STORE_KEY_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    // Same as above.
  }
};

export default SESSION_KEYS;
